import { createFileRoute } from '@tanstack/react-router';
import { UserManagementPage } from '../../../../pages';
import { PagesProvider } from '../../../../pages/providers/pages-provider';
import { guardUserManagement } from '../../../../router';
import { NavbarPageTemplate } from '../../../../templates';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/org-user-management')({
  staticData: {
    pageName: 'User Management',
  },
  beforeLoad: ({ context }) => guardUserManagement(context),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PagesProvider template={NavbarPageTemplate}>
      <UserManagementPage />
    </PagesProvider>
  );
}
